import React from "react";
import PropTypes from "prop-types";
import GlobalMergeModule from "./views/global-merge/GlobalMergeModule";
import RecordMergeModule from "./views/record-merge/RecordMergeModule";
import { ModalLayout } from "../modal/ModalLayout";
import Dispatcher from "Dispatcher";
import MergeActions from "data/MergeActions";
import MergeStore, { MERGE_PLUGINS } from "data/MergeStore";
import useFluxStore from "@armus/use-flux-store";
import SuperRecordActions from "data/SuperRecordActions";

class MergeModalView extends React.Component {
    constructor(props) {
        super(props);
        this.onClose = this.onClose.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        this.closeToken = Dispatcher.register(action => {
            if (action.type !== SuperRecordActions.CANCEL_FOR_OPTLOCK) return;
            this.onClose();
        });
    }

    componentWillUnmount() {
        if (this.closeToken != null) {
            Dispatcher.unregister(this.closeToken);
            delete this.closeToken;
        }
        this.onClose();
    }

    onClose() {
        const {
            view,
        } = this.props;
        view && view.close();
    }

    onCancel() {
        const {
            fluxContext,
        } = this.props;
        Dispatcher.contextDispatch(fluxContext, {
            type: MergeActions.CANCEL,
        });
        this.onClose();
    }

    render() {
        const {
            title = "Record Merge",
            fluxContext,
            mergePlugin,
        } = this.props;

        const modalOptions = {
            title: title,
            size: "modal-xlg"
        };
        let MergePlugin = null;
        switch(mergePlugin) {
            case MERGE_PLUGINS.GLOBAL_MERGE:
                MergePlugin = GlobalMergeModule;
                break;
            case MERGE_PLUGINS.RECORD_MERGE:
                MergePlugin = RecordMergeModule;
                break;
            case MERGE_PLUGINS.CHILD_MERGE:
                MergePlugin = "No child merge";
                break;
            default:
                throw Error(`Unknown merge modal plugin... "${mergePlugin}"`);
        }

        return (
            <ModalLayout
                modalOptions={modalOptions}
                triggerClose={this.onCancel}
                resizeBodyOnRender
            >
                <MergePlugin
                    fluxContext={fluxContext}
                    mergePlugin={mergePlugin}
                    onCancel={this.onCancel}
                />
            </ModalLayout>
        );
    }
}

MergeModalView.propTypes = {
    title: PropTypes.string.isRequired,
    fluxContext: PropTypes.string.isRequired,
    mergePlugin: PropTypes.string.isRequired,
    view: PropTypes.instanceOf(Backbone.Marionette.View),
};

export const MergeModalResolver = (props) => {
    const state = useFluxStore(() => {
        const mergeState = MergeStore.getState();
        return {
            title: mergeState.modalParams.title,
            mergePlugin: MergeStore.getPluginKey(),
        };
    }, [
        MergeStore,
    ], []);
    return state.mergePlugin ? <MergeModalView {...props} {...state} /> : null;
};

export default MergeModalResolver;



// WEBPACK FOOTER //
// ./app/lib/merge/MergeModalResolver.js